import axios from '@/util/axios';

const state = {
	name: <string | null> null,
	token: <string | null> null,
	username: <string | null> null,
	redirectToInterviewCode: <string | null> null
}

const getters = {
	name: (state: { name: string }) => state.name,
	token: (state: { token: string }) => state.token,
	username: (state: { username: string }) => state.username,
}

const mutations = {
	setName: (state: { name: string }, name: string) => state.name = name,
	setToken: (state: { token: string }, token: string) => {
		state.token = token
		axios.defaults.headers.common.Authorization = `Bearer ${token}`
	},
	setUsername: (state: { username: string }, username: string) => state.username = username,
}

const actions = {
	async getJwtToken(context: any, jwtId: string) {
		try {
			const response = await axios.get(`${process.env.VUE_APP_LOGIN_URL}NyGovGetUser?id=${jwtId}`);
			context.commit('setName', response.data.UserInfo.Name);
			context.commit('setToken', response.data.JwtToken);
			context.commit('setUsername', response.data.UserInfo.Username);
		}
		catch (error) {
			console.error(error);
		}
	},
	async logout(context: any) {
		axios.defaults.headers.common.Authorization = null;

		context.commit('setName', null);
		context.commit('setToken', null);
		context.commit('setUsername', null);
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
